import {Injectable} from '@angular/core';
import {SQDataConfiguration} from '../table/configuration/OData-configuration';
import {ODataEntitySetService, ODataServiceFactory} from 'angular-odata';
import {UploadHistory} from '../../features/history/models/historyLog';
import {exportable$} from '../table/decorators/exportable';
import {HelperFunctions} from '../table/configuration/helper-functions';
import {map} from 'rxjs/operators';
import {ODataResponseMapper} from '../table/mappers/odata-response-mapper';
import {ParentTableService} from '../table/parent-table.service';

@Injectable()
export class UploadHistoryService extends ParentTableService  {

  private config: SQDataConfiguration;
  private odata: ODataEntitySetService<UploadHistory>;
  @exportable$ uploadHistory: any;

  constructor(private odataFactory: ODataServiceFactory) {
    super('UploadHistoryService');
    this.config = new SQDataConfiguration();
    this.odata = this.odataFactory.entitySet<UploadHistory>('History');
  }

  getData(pageIndex, count, sortModel, filterModel) {
    const orders = [];
    sortModel.forEach(x => orders.push(x.colId + ' ' + x.sort));

    let filter = '';
    for (const i in filterModel) {
      if (filter.length === 0) {
        filter += HelperFunctions.filterObject(i, filterModel[i]);
      } else {
        filter += ' AND ' + HelperFunctions.filterObject(i, filterModel[i]);
      }
    }

    const query = this.odata.entities().query(q => {
      q.top(count);
      q.skip(count * pageIndex);
      if (orders.length > 0) q.orderBy(orders);
      if (filter?.length) q.filter(filter);
      return q;
    });

    this.uploadHistory = query;
    return this.uploadHistory.fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }
}
